
const environment = {
    env: 'dev',
}
export default environment